'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'sparkles';
var width = 576;
var height = 512;
var aliases = [10024];
var unicode = 'f890';
var svgPathData = ['M92.3 256l52.1 24.1c10.4 4.8 18.7 13.1 23.5 23.5l24.1 52.1 24.1-52.1c4.8-10.4 13.1-18.7 23.5-23.5l52.1-24.1-52.1-24.1c-10.4-4.8-18.7-13.1-23.5-23.5l-24.1-52.1-24.1 52.1c-4.8 10.4-13.1 18.7-23.5 23.5L92.3 256z', 'M391.5 53.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L448 96 469.2 152.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L512 96 568.5 74.8c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L512 32 490.8-24.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L448 32 391.5 53.2zM167.9 208.5l24.1-52.1 24.1 52.1c4.8 10.4 13.1 18.7 23.5 23.5l52.1 24.1-52.1 24.1c-10.4 4.8-18.7 13.1-23.5 23.5l-24.1 52.1-24.1-52.1c-4.8-10.4-13.1-18.7-23.5-23.5L92.3 256 144.5 231.9c10.4-4.8 18.7-13.1 23.5-23.5zM165.6 99.1l-41.2 89.3-89.3 41.2-.6 .3c-3.9 1.8-12.3 5.7-25.2 11.6-5.7 2.6-9.3 8.3-9.3 14.5s3.6 11.9 9.3 14.5c12.9 5.9 21.2 9.8 25.2 11.6l.6 .3 89.3 41.2 41.2 89.3 .3 .6c1.8 3.9 5.7 12.3 11.6 25.2 2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3c14.4-31.1 15.1-32.7 53.1-115l89.3-41.2 .6-.3c3.9-1.8 12.3-5.7 25.2-11.6 5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5c-31.1-14.4-32.7-15.1-115-53.1l-41.2-89.3-.3-.6c-1.8-3.9-5.7-12.3-11.6-25.2-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3c-13.8 29.8-11.5 25-11.9 25.8zM416 416l-56.5 21.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L416 480 437.2 536.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L480 480 536.5 458.8c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L480 416 458.8 359.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L416 416z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSparkles = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;